import React from 'react';
import { pdfStyles } from '../styles';
import { Page, Text, View } from '@react-pdf/renderer';

const FourthTable = ({
  renderTitles,
  renderSubTitles,
  disciplineList,
  setCountOfPage,
  semesterGrades,
}) => {
  const transformedData = semesterGrades && transformCoursesData(semesterGrades);

  function transformCoursesData(courses) {
    const semesterDisciplines = {};

    courses.forEach((course) => {
      Object.keys(course).forEach((key) => {
        if (key.includes('курс') && course[key] !== null) {
          const disciplineInfo = {
            Дисциплина: course['Дисциплина'],
            Оценка: course[key],
            Итоговая: course['Оценка в диплом'],
          };

          if (!semesterDisciplines[key]) {
            semesterDisciplines[key] = [];
          }

          semesterDisciplines[key].push(disciplineInfo);
        } else if (key.includes('курс') && course[key] === null && !semesterDisciplines[key]) {
          semesterDisciplines[key] = [];
        }
      });
    });

    return semesterDisciplines;
  }

  const renderTableHeader = () => (
    <View style={[pdfStyles.tableRow, pdfStyles.bigHeight, pdfStyles.bold, pdfStyles.center]}>
      <View style={pdfStyles.tableCol5}>
        <View style={pdfStyles.tableCol}>
          <Text>{'№ \n п/п'}</Text>
        </View>
      </View>
      <View style={pdfStyles.tableCol50}>
        <View style={pdfStyles.tableCol}>
          <Text style={pdfStyles.mt5}>{'Наименование учебной \n дисциплины'}</Text>
        </View>
      </View>
      <View style={pdfStyles.tableCol25}>
        <View style={pdfStyles.tableCol}>
          <Text style={pdfStyles.ml3}>{'Оценка по результатам промежуточной аттестации'}</Text>
        </View>
      </View>
      <View style={pdfStyles.tableCol25}>
        <View style={pdfStyles.tableCol}>
          <Text style={pdfStyles.ml3}>{'Итоговая оценка по дисциплине'}</Text>
        </View>
      </View>
    </View>
  );

  const renderSemester = (semester) => {
    return semester.map((item, index) => (
      <View style={[pdfStyles.tableRow]}>
        <View style={pdfStyles.tableCol5}>
          <View style={pdfStyles.tableCol}>
            <Text style={pdfStyles.center}>{index + 1 + '.'}</Text>
          </View>
        </View>
        <View style={pdfStyles.tableCol50}>
          <View style={pdfStyles.tableCol}>
            <Text style={pdfStyles.ml3}>{item.Дисциплина}</Text>
          </View>
        </View>
        <View style={pdfStyles.tableCol25}>
          <View style={pdfStyles.tableCol}>
            <Text style={[pdfStyles.ml3, pdfStyles.center]}>{item.Оценка}</Text>
            <Text style={pdfStyles.ml3}> </Text>
          </View>
        </View>
        <View style={pdfStyles.tableCol25}>
          <View style={pdfStyles.tableCol}>
            {/* <Text style={pdfStyles.ml3}>{' '}</Text> */}
            {/* <Text style={[pdfStyles.ml3, pdfStyles.center]}>{gradesResolver(item.Оценка)}</Text> */}
            <Text style={[pdfStyles.ml3, pdfStyles.center]}>{item.Итоговая}</Text>
          </View>
        </View>
      </View>
    ));
  };

  // const stack = [];
  // const withEmptyPeriod = Object.values(tableDataWithKeys).map((period) => Object.values(period)).map((two,i) => two.length === 2 ? two : i%2 !== 0 ? [[],...two] : [...two, []])
  // withEmptyPeriod.map(el => el.forEach(lol => stack.push(lol)))
  // const stack2 = [];
  // Object.values(tableDataWithKeys).map(period => Object.values(period).map((el,i) => stack.push(el) ))
  // Object.values(tableDataWithKeys).map(period => Object.keys(period).map((el,i) => stack2.push(el) ))
  // const rar =  Object.keys(tableDataWithKeys)
  // .map(period => Object.keys(tableDataWithKeys[period])
  //     .map(el => tableDataWithKeys[period][el])).forEach(el => {
  //         stack.push(el[0]);})

  const renderTable = () => {
    const render = [];

    let semesterOnPage = [];
    let itemsOnPage = [];
    let count = 0;

    const semesterList = disciplineList.reduce((acc, disc, i) => ({ ...acc, ...disc.list }), {});
    delete semesterList.eyid;
    Object.values(transformedData).forEach((semester, index) => {
      semester.length && semesterOnPage.push(index);
      itemsOnPage.push(semester.length);

      // 25 кол-во строчек на странице после шапки и семестров для перечисления предметов
      if (
        22 - itemsOnPage.reduce((acc, value) => acc + value, 0) <= 0 ||
        index + 1 === Object.values(transformedData).length
      ) {
        count = count + 1;

        const toRender = (
          <Page size="A4" style={pdfStyles.page}>
            {count == 1 && (
              <Text style={[pdfStyles.subTitle, pdfStyles.center]}>
                {'2. Портфолио достижений и работ'}
              </Text>
            )}
            {count > 1
              ? renderTitles(null, 'продолжение Раздел 1. Образовательная деятельность')
              : renderTitles(null, 'Раздел 1. Образовательная деятельность')}
            {/* {count > 1  ? renderTitles(null, "Раздел 1. Образовательная деятельность", "продолжение") : renderTitles(null, "Раздел 1. Образовательная деятельность")} */}
            {renderSubTitles('Портфолио достижений', 'Результаты обучения по теоретическому курсу')}
            <View style={pdfStyles.table}>
              {renderTableHeader()}
              {semesterOnPage.map((sem) => {
                //    const courses =  Object.values(transformedData).find((semester, i) =>   i === sem && semester)

                const courses = Object.entries(transformedData).find(
                  (semester) =>
                    semester[0].includes(`${sem + 1} семестр`) ||
                    semester[0].includes(`${sem + 1}-й семестр`)
                )[1];

                return (
                  courses && (
                    <>
                      <View style={pdfStyles.tableRow}>
                        <View style={[pdfStyles.tableCol, pdfStyles.tableCol105]}>
                          <Text style={[pdfStyles.center, pdfStyles.bold]}>
                            {!!courses?.length && `${sem + 1}-й семестр`
                            // ? `${sem +1}-й семестр`
                            // : `Данные по ${sem+1}-му семестру отсутствуют`
                            }
                          </Text>
                        </View>
                      </View>
                      {renderSemester(courses)}
                    </>
                  )
                );
              })}
            </View>
          </Page>
        );

        semesterOnPage = [];
        itemsOnPage = [];
        render.push(toRender);
      }
    });
    setCountOfPage(count);
    return render;
  };

  return renderTable();
};

export default FourthTable;
